import { createAsyncThunk } from '@reduxjs/toolkit';
import { getParams } from '../common/get-params';

// Store controller reference outside component to track between requests
let drilldownControllerRef = null;

const getPipelineCard = async (
  { timeFrame = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, filters, compare: true });
  const pipelineCardResponse = atsHttp.post(`/reports/pipeline/card`, params);
  return pipelineCardResponse;
};

const getPipelineTableAndChart = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(
    `/reports/pipeline/chart_table`,
    params
  );
  return hireCardResponse;
};

const getPipelineDrilldown = async (
  { timeFrame = {}, group = {}, filters = {}, drilldown = {}, customFilter },
  { extra: { atsHttp } }
) => {
  // Cancel any previously ongoing request
  if (drilldownControllerRef) {
    drilldownControllerRef.abort();
  }

  // Create a new controller for this request
  const controller = new AbortController();
  drilldownControllerRef = controller;

  try {
    const params = getParams({
      timeFrame,
      group,
      filters,
      drilldown,
      customFilter,
    });
    const response = await atsHttp.post(`/reports/pipeline/drilldown`, params, {
      signal: controller.signal,
    });
    return response;
  } catch (error) {
    // For AbortError and CanceledError, throw the error to trigger the rejected handler
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      throw error;
    }
    // For other errors, also throw
    throw error;
  }
};

export const fetchPipelineCard = createAsyncThunk(
  'ats-reports/pipeline/card',
  getPipelineCard
);

export const fetchPipelineTableAndChart = createAsyncThunk(
  'ats-reports/pipeline/table-chart',
  getPipelineTableAndChart
);

export const fetchPipelineDrilldown = createAsyncThunk(
  'ats-reports/pipeline/drilldown',
  getPipelineDrilldown
);
